import { useEffect, useState } from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

import sliderImg1 from "../../assets/images/slider/slider_spess_1.jpg";
import sliderImg2 from "../../assets/images/slider/slider_spess_2.jpg";
import sliderImg11 from "../../assets/images/slider/slider_spess_3.jpg";
import sliderImg12 from "../../assets/images/slider/12.jpg";
import { fetchImages } from '../../util/galerija';

const HomeSlider = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [sliderImages, setSliderImages] = useState(false);
    const openModal = () => setIsOpen(!isOpen);

    useEffect (()=>{
        fetchSliderImages("1jwf2GDAC5eWwKk6fJgLFl8ad56Wo_sNN")
        
    },[])

    const fetchSliderImages = async(folderId) =>{
        const response = await fetchImages(folderId)
        setSliderImages(response)
    }

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        margin: 0,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,         // Vključi avtomatsko premikanje slik
        autoplaySpeed: 3000,    // Nastavi čas na 3000ms (3 sekunde)
        pauseOnHover: true,  
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: true,
                }
            }
        ]
    };

    return (
        <>
            <div className="react-slider-part">
                <ModalVideo channel='youtube' isOpen={isOpen} videoId='e5Hc2B50Z7c' onClose={() => { openModal(); }} />
                <div className="home-sliders home2">
                    <Slider {...sliderSettings}>
                        {sliderImages ?
                        sliderImages.map((img)=>(
                            <div className="single-slide">
                            <div className="slider-img">
                                <img className="desktop" style={{aspectRatio: 128/60, width: "100%", objectFit: "cover"}} src={img.url} alt={img.name} />
                                <img className="mobile" src={img.url} alt={img.name}  />
                            </div>                  
                        </div>
                        ))
                        :(<div className="single-slide">
                            <div className="slider-img">
                                <img className="desktop" src={sliderImg1} />
                                <img className="mobile" src={sliderImg11} alt="Slider Image 1" />
                            </div>                  
                        </div>)
                        }

                        
                    </Slider>
                </div>
            </div>
        </>
    );
}

export default HomeSlider;